import { Directive, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import OfficeFluentProvider from '@office-start/office-fluent-provider';
import RecommendedComponent from '@office-start/recommended-component';

import * as React from 'react';

import { FileType } from '../shared/models/file-item.model';
import { initializeFluentIcons } from '../shared/office-start/initialize-fluent-icons';
import { OfficeStartBootstrapperService } from '../shared/office-start/office-start-bootstrapper.service';
import ReactRenderer from '../shared/react/react-renderer';
import { CapabilitiesService } from '../shared/shared-context/capabilities.service';
import { ClientStartupConfigService } from '../shared/shared-context/client-startup-config.service';
import { ContextService } from '../shared/shared-context/context.service';

@Directive({ selector: 'ohp-recommended-react-content' })
export class RecommendedReactContentDirective extends ReactRenderer implements OnInit, OnDestroy {
    @Input() public fileType: FileType;

    constructor(
        elementRef: ElementRef,
        private readonly capabilitiesService: CapabilitiesService,
        private readonly clientStartupConfigService: ClientStartupConfigService,
        private readonly contextService: ContextService,
        private readonly officeStartBootstrapperService: OfficeStartBootstrapperService
    ) {
        super(elementRef);
    }

    public ngOnInit () {
        super.ngOnInit();
        this.officeStartBootstrapperService.bootstrapOfficeStart();
        initializeFluentIcons(this.capabilitiesService, this.contextService, this.clientStartupConfigService);
    }

    public ngOnDestroy() {
        super.ngOnDestroy();
    }

    public async getReactElement() {
        return (
            <OfficeFluentProvider className='recommended-provider'>
                <RecommendedComponent
                    fileType={this.fileType ? FileType[this.fileType].toString() : undefined}
                    useFeedApi={true}>
                </RecommendedComponent>
            </OfficeFluentProvider>
        );
    }
}
